import React from 'react'
import { User, UserRole } from '@myapp/contract'
import { ListItem } from '../../../shared/ui/list/ListIteam/ListItem'
import { getPositionsFromRoles, canEditUser, canArchiveUser, canRestoreUser } from '../../../entities/user'
import { routes } from '../../../shared/config/routes'
import { userColumns } from '../model/constants'
import { IconButton } from '../../../shared/ui/icons/IconButton/IconButton'
import { Pencil, Archive, ArchiveRestore } from 'lucide-react'

interface Props {
  item: User
  actorRoles: UserRole[]
  actorId?: string
  gewerkLabels?: Map<number, string>
  onArchive: (id: string, name: string) => void
  onRestore: (id: string, name: string) => void
}

function formatTrades(tradeIds: number[] | undefined, labels?: Map<number, string>): string {
  if (!tradeIds || tradeIds.length === 0) return '–'
  return tradeIds.map((id) => labels?.get(id) ?? `#${id}`).join(', ')
}

export const UserListItem: React.FC<Props> = ({ item, actorRoles, actorId, gewerkLabels, onArchive, onRestore }) => {
  const isArchived = !!item.archivedAt

  const editLink = !isArchived && canEditUser(actorRoles, item.roles)
    ? routes.users.edit(item.id)
    : undefined

  const trades = item.technicianProfile?.trades

  return (
    <ListItem
      columns={userColumns}
      link={editLink}
      actionsOnHover
      actions={
        <>
          {!isArchived && canEditUser(actorRoles, item.roles) && (
            <IconButton
              icon={<Pencil size={16} />}
              onClick={() => {}}
              aria-label="Bearbeiten"
            />
          )}
          {!isArchived && canArchiveUser(actorRoles, item.roles) && item.id !== actorId && (
            <IconButton
              icon={<Archive size={16} />}
              onClick={(e) => { e.preventDefault(); onArchive(item.id, item.name) }}
              aria-label="Archivieren"
            />
          )}
          {isArchived && canRestoreUser(actorRoles, item.roles) && (
            <IconButton
              icon={<ArchiveRestore size={16} />}
              onClick={(e) => { e.preventDefault(); onRestore(item.id, item.name) }}
              aria-label="Wiederherstellen"
            />
          )}
        </>
      }
    >
      <ListItem.Cell>{item.name || '-'}</ListItem.Cell>
      <ListItem.Cell>{item.email}</ListItem.Cell>
      <ListItem.Cell>{getPositionsFromRoles(item.roles)}</ListItem.Cell>
      <ListItem.Cell>{formatTrades(trades, gewerkLabels)}</ListItem.Cell>
      <ListItem.Cell>{isArchived ? 'Archiviert' : 'Aktiv'}</ListItem.Cell>
    </ListItem>
  )
}
